// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__2NQic","spin":"Spinner_spin__2kYs0","colorshift":"Spinner_colorshift__2Q97S"};